import { jwtDecode } from "jwt-decode";
// import { handleError } from "../Utils";

export const getEmail = () => {
  const token = localStorage.getItem("token");
  console.log("Token:", token);
  if (token) {
    const decoded = jwtDecode(token);
    console.log("Decoded:", decoded);
    return decoded.email;
  }
  // return handleError("Token not found"); // Return null if no token is found
};

export const getRole = () => {
  const token = localStorage.getItem("token");
  console.log("Token:", token);
  if (token) {
    const decoded = jwtDecode(token);
    console.log("Decoded:", decoded);
    return decoded.role;
  }
};
